import PropTypes from "prop-types";
import { Card } from "@mantine/core";
import FetchFeedback from "../../../ui/CustomFetchFeedback/CustomFetchFeedback";
import BulkStatCardSkeleton from "../BulkStatCardSkeleton";

export default function BulkStatCard({
  icon,
  iconBgClass,
  metricText,
  metricColorClass,
  label,
  value,
  isLoading,
  isError,
  onRetry,
  errorMessage,
}) {
  if (isLoading) return <BulkStatCardSkeleton />;

  if (isError) {
    return (
      <Card
        radius="lg"
        className="min-h-[140px] flex items-center justify-center p-5"
      >
        <FetchFeedback
          message={errorMessage}
          onRetry={onRetry}
          fullHeight={false}
          compact
        />
      </Card>
    );
  }

  return (
    <Card radius="lg" className="min-h-[140px] p-5 sm:p-6">
      <div className="flex flex-col h-full">
        <div className="flex items-start justify-between">
          <div
            className={`rounded-xl w-9 h-9 flex-shrink-0 flex items-center justify-center text-lg ${iconBgClass}`}
          >
            {icon}
          </div>
          <span
            className={`text-xs font-medium ml-2 text-right ${metricColorClass ?? ""}`}
          >
            {metricText}
          </span>
        </div>
        <div className="mt-4">
          <p className="text-xs text-gray-500 font-medium uppercase tracking-wide">
            {label}
          </p>
          <p className="text-xl font-bold text-gray-900 mt-1">{value}</p>
        </div>
      </div>
    </Card>
  );
}

BulkStatCard.propTypes = {
  icon: PropTypes.node.isRequired,
  iconBgClass: PropTypes.string.isRequired,
  metricText: PropTypes.node,
  metricColorClass: PropTypes.string,
  label: PropTypes.string.isRequired,
  value: PropTypes.node,
  isLoading: PropTypes.bool.isRequired,
  isError: PropTypes.bool.isRequired,
  onRetry: PropTypes.func.isRequired,
  errorMessage: PropTypes.string.isRequired,
};
